export const environment = {
    apiUrl: 'https://truckhandel-dev-edczf0aufnh4b8aq.z02.azurefd.net/api',
    firebase: {
        apiKey: "AIzaSyBEbNBzTK_vhZ0AiLoeVceNGPjGYFuYZyg",
        authDomain: "truckhandel-dev.firebaseapp.com",
        projectId: "truckhandel-dev",
        storageBucket: "truckhandel-dev.firebasestorage.app",
        messagingSenderId: "370791212780",
        appId: "1:370791212780:web:eacc00c2cada6fdb4fa7c9"
    }
};
